import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgotten-password-sent',
  templateUrl: './forgotten-password-sent.component.html',
  styleUrls: ['./forgotten-password-sent.component.scss'],
  host: { 'class': 'login-main' }
})
export class ForgottenPasswordSentComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }
}
